import { fm, privacyLevels } from 'lib/localization'

export const orgVisibility = ['Public', 'Route Managers Only', 'Members Only']
export const intlOrgVisibility = intl => ([
  fm(intl, privacyLevels.public),
  fm(intl, privacyLevels.rmOnly),
  fm(intl, privacyLevels.mOnly)
])

export const userVisibility = ['Public', 'Private', 'Friends Only']
export const intlUserVisibility = intl => ([
  fm(intl, privacyLevels.public),
  fm(intl, privacyLevels.private),
  fm(intl, privacyLevels.friendsOnly)
])
